import React, { useState, CSSProperties  } from 'react'
import { Box } from "@mui/material";
import bg_login from "../images/bg-login.png";
import bg_5 from "../images/bg5.png";
import bg_6 from "../images/bg6.png";
import fb from "../images/fb.png";
import google from "../images/google.png";
import fb_sm from "../images/fb-sm.png";
import google_sm from "../images/google-sm.png";
import { Link } from "react-router-dom";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Axios from 'axios';
import HeaderThree from './header/HeaderThree';

// import sc from "./CSS/card.css";
import "./CSS/login.css"


import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { GoogleLogin } from 'react-google-login';


// spinner
import ClipLoader from "react-spinners/PropagateLoader";
import { css } from "@emotion/react";
const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
        `;

const Login = () => {
    const [showPassword, setPasswordShown] = useState(false);
    const togglePassword = () => {
        setPasswordShown(!showPassword);
    };

    const clientId = '848915360523-654tco324v1fibeq998o6ucmh05cspc6.apps.googleusercontent.com';


    const [showemail, setEmail] = useState('');
    const [showpassword, setPassword] = useState('');
    const [showError, setError] = useState(false);
    const [showError2, setError2] = useState(false);

    let [loading, setLoading] = useState(false);



    const login = () => {
        setError(false);
        setError2(false);
        setLoading(true);

        Axios.post(window.rootlink+"/login", {
            email: showemail,
            password:showpassword
        }).then((v)=>{
            console.log(v);
            console.log(v['data']['status']);
            if(v['data']['status'] == 1){
                window.location.href = "/";
            }else if(v['data']['status'] == 2){
                setError2(true);
                setLoading(false);
                
            }else{
                setError(true);
                setLoading(false);

            }
        });
    };


    const loginSocial = (email_) => {
        setError(false);
        setError2(false);
        setLoading(true);
        Axios.post(window.rootlink+"/login-social", {
            email: email_
        }).then((v)=>{
            console.log(v);
            console.log(v['data']['status']);
            if(v['data']['status'] == 1){
                window.location.href = "/";
            }else if(v['data']['status'] == 2){
                setError2(true);
                setLoading(false);
            }else{
                setError(true);
                setLoading(false);
            }
        });
    };

   

    const onSuccess = (response) =>{
        alert(response);
    }

    const onFail = (res) =>{
        console.log(res);
    }

    const responseGoogle = (response) => {
        console.log(response.profileObj);
        loginSocial(response.profileObj.email);
      }

    const responseFacebook = (response) => {
        console.log(response.name);
        console.log(response.email);
        console.log(response.picture['data']['url']);
        if(response.email == null){
            setError(true);
        }else{
            loginSocial(response.email);
        }
    }
    
    return (

        
        <>
        {/* <HeaderThree /> */}
        <div >
            <Link 
                to="/"
                className="home-button"
            >
                <h4 style={{
                    marginRight: "7px",
                    color: "#ff2c48",
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                    </svg>
                </h4>
                <h4 style={{color: "#bdadad"}}>Home</h4>
            </Link>
        </div>

        <link href="/card.css" rel="stylesheet" type="text/css" />
            <Box
                sx={{
                    background: "transparent",
                    width: { md: "100%", xs: "92%" },
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: { md: "row", xs: 'column' },
                    backgroundImage: { md: `url(${bg_login})`, xs: "none" },
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "auto",
                    backgroundPosition: "left",
                    margin: { md: "174px  auto 0", xs: "120px auto 90px" },
                    "&::after": {
                        content: "''",
                        backgroundImage: { md: `url(${bg_5})`, xs: `url(${bg_6})` },
                        bottom: { md: "0", xs: "auto" },
                        left: { md: "auto", xs: "0" },
                        top: { md: "auto", xs: "90px" },
                        right: { md: "0", xs: "none" },
                        position: "absolute",
                        width: { md: "240px", xs: "84px" },
                        height: { md: "970px", xs: "355px" },
                        zIndex: "-1",
                    },
                    "&::before": {
                        content: "''",
                        background: "rgba(100, 151, 255, 0.3)",
                        filter: "blur(200px)",
                        right: 0,
                        bottom: 0,
                        position: "absolute",
                        display: { md: "block", xs: "none" },
                        width: "770px",
                        height: "617px",
                        zIndex: "-1",
                    }
                }}
            >
                <div className="container login">
                    <Box
                        sx={{
                            background: "transparent",
                            justifyContent: "right",
                            alignItems: "center",
                            margin: { md: "0 auto 20px", xs: "10px auto" },
                            width: "100%",
                            display: "flex",
                            flexDirection: { md: "row", xs: 'column' },
                        }}
                    >
                        <div className="form">
                            <div className="form-title">Log in</div>
                            <div className="btn-gp">

                                <GoogleLogin
                                    clientId={'848915360523-654tco324v1fibeq998o6ucmh05cspc6.apps.googleusercontent.com'}
                                    onSuccess={responseGoogle}
                                    onFailure={onFail}
                                    cookiePolicy={'single_host_origin'}
                                    className={'btn-social'}
                                    render={renderProps => (
                                        <button className="btn-social" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                            <img className="lg" src={google} alt="alt='signup with Google" />
                                            <img className="sm" src={google_sm} alt="alt='signup with Google" />
                                        </button>
                                      )}
                                    
                                />

                                
                                {/* <button className="btn-social">
                                    <img className="lg" src={google} alt="alt='signup with Google" />
                                    <img className="sm" src={google_sm} alt="alt='signup with Google" />
                                </button> */}


                                {/* <FacebookLogin
                                    appId="983175575727533"
                                    autoLoad={false}
                                    fields="name,email,picture"
                                    callback={responseFacebook}
                                    render={renderProps => (
                                        <button className="btn-social" onClick={renderProps.onClick}>
                                        <img className="lg" src={fb} alt='signup with Facebook' />
                                        <img className="sm" src={fb_sm} alt='signup with Facebook' />
                                        </button>
                                      )}
                                    /> */}



                                <button className="btn-social">
                                    <img className="lg" src={fb} alt='signup with Facebook' />
                                    <img className="sm" src={fb_sm} alt='signup with Facebook' />
                                </button>



                            </div>
                            <div className="form-p"> -OR- </div>
                            <form action="" method="post" onSubmit={(e)=>{e.preventDefault();}}>
                                <input type="text" name="full_name" id="full_name" placeholder='Full Name' onChange={(v)=> {setEmail(v.target.value);}} />
                                <input type={showPassword ? "text" : "password"} name="password" id="password" placeholder='Password' onChange={(v)=>{
                                    setPassword(v.target.value);
                                }} />
                                <div onClick={togglePassword} className="icon">
                                    {showPassword ?
                                        <VisibilityIcon sx={{ color: "#fff" }} /> :
                                        <VisibilityOffIcon sx={{ color: "#bdadad" }} />
                                        
                                    }
                                </div>

                                { showError ?

                                    <span style={{color:'red'}} >Email or password not correct</span> :  <span></span>

                                }

                                
                                { showError2 ?

                                <span style={{color:'red'}} >You account not approved yet</span> :  <span></span>

                                }

                                {/* <Link to="/nft_marketplace" style={{padding:'0'}} className="button btn-form">Login</Link> */}
                                <button className='button btn-form' style={{padding:'0'}} onClick = {login}>
                                    {loading ? <span></span> : 'Login'}
                                    <ClipLoader color={'#ffff'} loading={loading} css={override} size={10} />
                                    </button>
                                

                            </form>
                            <div className="already">
                                <span>Not a member?</span>
                                <Link to="/register">Sign Up</Link>
                            </div>
                        </div>
                    </Box>
                </div>
            </Box>
        </>
    )
}

export default Login